// extracted by mini-css-extract-plugin
export default {"tagsContainer":"TemplateTagsWithVisibleLimit_tagsContainer__TtRXN","tags":"TemplateTagsWithVisibleLimit_tags__KuEy5","hiddenCount":"TemplateTagsWithVisibleLimit_hiddenCount__MgTvC"};